import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { fetchFeatures, fetchPermissions, fetchUserProfile } from 'api/auth'
import { checkNewMessages } from 'api/messages'
import { fetchPartnerDetails } from 'api/partner'
import { useDispatch, useSelector } from 'react-redux'
import { UPDATE_PARTNER } from 'reducers/user'
import { get_fb_sessions_key } from 'components/Settings/Meta/connect'
import { metaAssetsApi } from 'api/connect/meta'
import { useCognitoDispatch } from './CognitoContextProvider'

const initialState = {
  isLogged: false,
}

export function usePostLoginRedirect(onSuccess) {
  const { i18n } = useTranslation()
  const [loginState, setLoginState] = useState(initialState)
  const [showSplash, setShowSplash] = useState(false)
  const user = useSelector((state) => state.user)
  const dispatch = useDispatch()
  const [selectedPartner, setSelectedPartner] = useState(null)
  const { requiresMFA } = useCognitoDispatch()

  useEffect(() => {
    const fetchData = async () => {
      await fetchFeatures(dispatch)
      await fetchPermissions(dispatch)
      await fetchUserProfile(dispatch, i18n)
      await checkNewMessages(dispatch)
      await fetchPartnerDetails(dispatch)
    }

    const redirect = async () => {
      setTimeout(() => {
        setLoginState((prevState) => {
          return {
            ...prevState,
            isLogged: true,
            accessLevel: user.accessLevel,
          }
        })
      }, 750)
    }

    if (user.cognitoGroups && user.cognitoGroups.length === 1) {
      const partner = user.cognitoGroups[0]
      setSelectedPartner(partner)
      localStorage.setItem('clientId', partner)
      dispatch({ type: UPDATE_PARTNER, payload: partner })
    }

    const mfaRequired = requiresMFA()
    if (mfaRequired === undefined) {
      return // do nothing until we know if MFA is required
    }
    if (selectedPartner && !showSplash && !mfaRequired) {
      if (user.isLogged) fetchData()
      setShowSplash(true)
      redirect()
    }
    if (user.isLogged && onSuccess) {
      onSuccess()
    }
  }, [
    user.isLogged,
    user.accessLevel,
    user.cognitoGroups,
    dispatch,
    i18n,
    showSplash,
    selectedPartner,
    onSuccess,
    requiresMFA,
  ])

  useEffect(() => {
    const triggerAssetRefetchAsync = async () => {
      let cachedFbSessions = localStorage.getItem(get_fb_sessions_key())
      cachedFbSessions = cachedFbSessions ? JSON.parse(cachedFbSessions) : []
      if (!cachedFbSessions.length) {
        return
      }
      await metaAssetsApi.triggerAssetRefetch({
        platformUserIds: cachedFbSessions
          .filter((x) => x.loggedIn)
          .map((session) => session.platformUserId),
      })
    }

    if (user.isLogged && selectedPartner) {
      triggerAssetRefetchAsync()
    }
  }, [user.isLogged, selectedPartner])

  return {
    loginState,
    showSplash,
    setShowSplash,
    selectedPartner,
    setSelectedPartner,
  }
}
